import { render, staticRenderFns } from "./confirmOverlap.vue?vue&type=template&id=206b7192&scoped=true&"
import script from "./confirmOverlap.vue?vue&type=script&lang=js&"
export * from "./confirmOverlap.vue?vue&type=script&lang=js&"
import style0 from "./confirmOverlap.vue?vue&type=style&index=0&id=206b7192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b7192",
  null
  
)

export default component.exports